import { render, staticRenderFns } from "./SalesDescriptions.vue?vue&type=template&id=221c6379&"
import script from "./SalesDescriptions.vue?vue&type=script&lang=js&"
export * from "./SalesDescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports